











































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AppModal extends Vue {
  @Prop({ required: true }) public show!: boolean;
  @Prop() public width!: number;
  @Prop({ default: false }) public noPadding!: boolean;
  @Prop({ default: false }) public noHeader!: boolean;
  @Prop({ default: false }) public noFooter!: boolean;
}
